var map = {
	"./authapi.js": "a94f",
	"./authfack.js": "8dd5",
	"./layout.js": "c21a",
	"./merchant.js": "bd45",
	"./notification.js": "2208",
	"./paging.js": "982d",
	"./pos.js": "6b92",
	"./posgroup.js": "6b8f",
	"./product.js": "1665",
	"./reports.js": "2123"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";